import { useWindowSize } from '@app/hooks/useWindowSize';
import { setWindowSize } from '@app/store/reducers/ui';
import { calculateWindowSize } from '@app/utils/helpers';
import ForgetPassword from '@modules/forgot-password/ForgotPassword';
import Login from '@modules/login/Login';
import Main from '@modules/main/Main';
import RecoverPassword from '@modules/recover-password/RecoverPassword';
import Dashboard from '@pages/Dashboard';
import Profile from '@pages/profile/Profile';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Links } from './helpers/Links';
import { routers } from './helpers/RouterMapping';
import LoginSSO from './modules/login/LoginSSO';
import NotFound from './pages/notfound/NotFound';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import Dashboard2 from './pages/Dashboard2';


const App = () => {
    const windowSize = useWindowSize();
    const screenSize = useSelector((state: any) => state.ui.screenSize);
    const dispatch = useDispatch();
    //const isAvailableMenu = useSelector((state: any) => state.menu.isAvailableMenu);
    const isAvailableMenu = !!localStorage.getItem('menu');
    const menuState = useSelector((state: any) => state.menu.items);
    const menuLocal = JSON.parse(localStorage.getItem('menu') || '{}');
    useEffect(() => {
        const size = calculateWindowSize(windowSize.width);
        if (screenSize !== size) {
            dispatch(setWindowSize(size));
        }
    }, [windowSize]);

    const renderElements = (menu: any) => {
        return routers.map((x, index) => renderRouters(x, index, menu));
    }

    const renderRouters = (sw: any, index: number, menu: any) => {
        let routers = [];
        for (let key in sw) {
            if (PathMapToMenu(key, menu)) {
                routers.push(
                    <Route path={key} element={sw[key]} />
                );
            }
        }
        return routers;
    }

    const PathMapToMenu = (path: string, menu: any) => {
        if ((menu || []).length === 0) {
            return false;
        }

        for (let i = 0; i < menu.length; i++) {
            let url = menu[i].url || "";

            let regex = new RegExp("^/?" + url.trim().replace(/\/\//g, "/") + "(/:[a-zA-Z]*)?$");
            var isMap = (url.length > 0 && regex.test(path)) || PathMapToMenu(path, menu[i].children);
            if (isMap) {
                return true;
            }
        }
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<PublicRoute />}>
                    <Route path="/login" element={<Login />} />
                </Route>
                <Route path={Links.CasService.CasClient} element={<LoginSSO />}>
                </Route>
                <Route path="/forgot-password" element={<PublicRoute />}>
                    <Route path="/forgot-password" element={<ForgetPassword />} />
                </Route>
                <Route path="/recover-password" element={<PublicRoute />}>
                    <Route path="/recover-password" element={<RecoverPassword />} />
                </Route>
                <Route path="/" element={<PrivateRoute />}>
                    <Route path="/" element={<Main />}>
                        {renderElements(isAvailableMenu ? menuLocal : menuState)}
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/notfound" element={<NotFound />} />
                        <Route path="/" element={<Dashboard />} />
                    </Route>
                </Route>
            </Routes>
            <ToastContainer
                autoClose={3000}
                draggable={false}
                position="top-right"
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnHover
            />
        </BrowserRouter>
    );
};

export default App;
